export enum SnackbarSnackTypeEnum {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export interface SnackbarSnackInterface {
  type: SnackbarSnackTypeEnum;
  text: string;
  hasCloseButton?: boolean;
}
